import { REDUCE_POLICY_LOG_CONTENT } from '../../constants/actions/policy';

export function reducePolicyLogContent(payload) {
    return {
        type: REDUCE_POLICY_LOG_CONTENT,
        payload,
    };
}
